import { Check } from "lucide-react";
import { cn } from "@/lib/cn";

/** `parcial`: configurando vários de uma vez, o que só parte deles tem. */
type Estado = "normal" | "marcado" | "revisado" | "parcial";

const ESTILO: Record<Estado, string> = {
  normal: "border-zinc-200 bg-white hover:border-brand-300 hover:bg-zinc-50 dark:border-border dark:bg-card dark:hover:bg-muted/40",
  marcado: "border-emerald-500 bg-emerald-50 dark:border-emerald-500/70 dark:bg-emerald-500/10",
  revisado: "border-emerald-500 bg-emerald-50 dark:border-emerald-500/70 dark:bg-emerald-500/10",
  parcial: "border-dashed border-emerald-400 bg-white hover:bg-emerald-50/50 dark:border-emerald-500/60 dark:bg-card",
};

const SELO: Record<Estado, string> = {
  normal: "",
  marcado: "bg-emerald-500",
  revisado: "bg-emerald-500",
  parcial: "",
};

/** Cartão pequeno, só texto, de um serviço, procedimento ou material — marcado ou revisado (verde). */
export function CartaoDeItem({
  titulo,
  detalhe,
  estado,
  onClick,
  alternavel = true,
}: {
  titulo: string;
  detalhe?: string;
  estado: Estado;
  onClick: () => void;
  /** Falso quando o clique abre algo em vez de marcar (Configurar). */
  alternavel?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={alternavel ? estado === "marcado" : undefined}
      className={cn("relative flex h-full min-h-[64px] w-full flex-col justify-center rounded-lg border px-3 py-2.5 text-left transition-colors", ESTILO[estado])}
    >
      <span
        className={cn(
          "block pr-5 text-[13px] font-medium leading-snug [overflow-wrap:anywhere]",
          estado === "marcado" ? "text-emerald-900 dark:text-emerald-300" : estado === "revisado" ? "text-emerald-900 dark:text-emerald-300" : "text-zinc-800 dark:text-foreground",
        )}
      >
        {titulo}
      </span>
      {detalhe && <span className="mt-0.5 block truncate text-[11.5px] text-zinc-500 dark:text-muted-foreground">{detalhe}</span>}
      {(estado === "marcado" || estado === "revisado") && (
        <span className={cn("absolute right-2 top-2 flex h-4 w-4 items-center justify-center rounded-full text-white", SELO[estado])}>
          <Check className="h-3 w-3" strokeWidth={3} />
        </span>
      )}
    </button>
  );
}
